define('models/LanguageModel',['underscore','ObjectModel','LocalStorage','site_vars'],function (_,ObjectModel,LocalStorage,site_vars) {
    //
    // Model Language
    //
    var LanguageModelPrototype = {
        
        name:'LanguageModel',
        idAttribute:'id_lang',
        
        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
        },
        getNameIso:function() {
	        return this.get('iso_code').toUpperCase();
        },
	    getIsoCode:function() {
		    return this.get('iso_code');
	    },
        isCurrent:function(){
            return site_vars.iso_lang == this.get('iso_code');
        }
    };

    var LanguageModel = ObjectModel.extend(LocalStorage).extend(LanguageModelPrototype);
    
    return LanguageModel;
});
